import { TextTypesOptions } from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'

export enum TitleSubtitleLayoutTypes {
  BOLD_TITLE = 'BOLD_TITLE',
  BOLD_SUBTITLE = 'BOLD_SUBTITLE',
  READ_ONLY = 'READ_ONLY',
  HORIZONTAL = 'HORIZONTAL',
  SETTLED = 'SETTLED',
  TO_BE_SETTLED = 'TO_BE_SETTLED',
  BOLD_TITLE_TRENDS = 'BOLD_TITLE_TRENDS',
  HORIZONTAL_SUBTITLE = 'HORIZONTAL_SUBTITLE',
  HORIZONTAL_BOLD = 'HORIZONTAL_BOLD',
}

export enum TitleSubtitleLayoutColorTheme {
  BOLD_TITLE = 'BOLD_TITLE',
  BOLD_SUBTITLE = 'BOLD_SUBTITLE',
  HORIZONTAL = 'HORIZONTAL',
  READ_ONLY = 'READ_ONLY',
  SETTLED = 'SETTLED',
  TO_BE_SETTLED = 'TO_BE_SETTLED',
  BOLD_TITLE_TRENDS = 'BOLD_TITLE_TRENDS',
}

export const titleTypes = {
  BOLD_TITLE: 'h5' as TextTypesOptions,
  BOLD_SUBTITLE: 'h6' as TextTypesOptions,
  HORIZONTAL: 'h6' as TextTypesOptions,
  READ_ONLY: 'caption' as TextTypesOptions,
  SETTLED: 'body2' as TextTypesOptions,
  TO_BE_SETTLED: 'body2' as TextTypesOptions,
  BOLD_TITLE_TRENDS: 'headline' as TextTypesOptions,
  HORIZONTAL_BOLD: 'h0Bold' as TextTypesOptions,
  HORIZONTAL_SUBTITLE: 'h3Bold' as TextTypesOptions,
}

export const subTitleTypes = {
  BOLD_TITLE: 'h6' as TextTypesOptions,
  BOLD_SUBTITLE: 'h5' as TextTypesOptions,
  HORIZONTAL: 'h6' as TextTypesOptions,
  READ_ONLY: 'body2' as TextTypesOptions,
  SETTLED: 'body3' as TextTypesOptions,
  TO_BE_SETTLED: 'body3' as TextTypesOptions,
  BOLD_TITLE_TRENDS: 'h3' as TextTypesOptions,
  HORIZONTAL_BOLD: 'title16' as TextTypesOptions,
  HORIZONTAL_SUBTITLE: 'title18' as TextTypesOptions,
}

export const titleColorMap = () => {
  return {
    BOLD_TITLE: defaultColors.BLACK,
    BOLD_SUBTITLE: defaultColors.PRIMARY_GREY,
    HORIZONTAL: defaultColors.DARK_GREY,
    READ_ONLY: defaultColors.PRIMARY_GREY,
    SETTLED: defaultColors.PRIMARY_GREY,
    TO_BE_SETTLED: defaultColors.PRIMARY_GREY,
    BOLD_TITLE_TRENDS: defaultColors.BLACK,
  }
}

export const subTitleColorMap = () => {
  return {
    BOLD_TITLE: defaultColors.PRIMARY_GREY,
    BOLD_SUBTITLE: defaultColors.BLACK,
    HORIZONTAL: defaultColors.DARK_GREY,
    READ_ONLY: defaultColors.BLACK,
    SETTLED: defaultColors.BLACK,
    TO_BE_SETTLED: defaultColors.BLACK,
    BOLD_TITLE_TRENDS: defaultColors.PRIMARY_GREY,
  }
}

export interface TitleSubtitleLayoutProps {
  type: TitleSubtitleLayoutTypes
  setFieldValue?: (field: string, value: string | number) => void
  color: TitleSubtitleLayoutColorTheme
  placeHolder?: string
  title?: string
  fieldName?: string
  hideIcon?: boolean
  onIconPress?: () => void
  tooltip?: string
}

export type func = () => void
